import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-spin',
  templateUrl: './loading-spin.component.html',
})
export class LoadingSpinComponent {}
